var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_credits",
    "data-name": "Group credits",
    transform: "translate(-0.59 -2.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M5,33.754c-2.225-.3-3.907-2.718-3.907-5.2V8.548C1.09,5.579,3.151,3.16,5.7,3.16H30.746c2.543,0,4.614,2.407,4.614,5.388v1.88",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1360",
    "data-name": "Rectangle 1360",
    width: 34.27,
    height: 30.71,
    rx: 4.5,
    transform: "translate(6.82 12.45)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M10.85,27.37h7.56c.19,0,.34.22.34.49v1.65c0,.27-.15.49-.34.49H10.85c-.19,0-.34-.22-.34-.49V27.86C10.51,27.59,10.66,27.37,10.85,27.37Z",
    transform: "translate(0.259 5.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1361",
    "data-name": "Rectangle 1361",
    width: 34.27,
    height: 2.46,
    transform: "translate(6.82 21.598)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageGroupIcon);
export default __webpack_public_path__ + "static/media/message-group-icon.29d152a6adf761ec202cad85c41c0982.svg";
export { ForwardRef as ReactComponent };